<template>
  <div>
    <v-list-item
      class="list-item-internal"
      v-if="
        !this.isSitecoreExperienceEditorOn &&
        this.isInternal &&
        this.linkField != null &&
        this.linkField.value != null
      "
      :to="this.linkField.value.href"
      :target="this.linkField.value.target"
    >
      <v-list-item-icon
        v-if="this.iconField != null && this.iconField.fields.IconName.value != null"
      >
        <v-icon v-text="this.iconField.fields.IconName.value"></v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ this.linkField.value.text }}
      </v-list-item-title>
    </v-list-item>

    <v-list-item
      class="list-item-external"
      v-else-if="
        !this.isSitecoreExperienceEditorOn &&
        !this.isInternal &&
        this.linkField != null &&
        this.linkField.value != null
      "
      :href="this.linkField.value.href | fixTelephoneLink"
      :target="this.linkField.value.target"
    >
      <v-list-item-icon
        v-if="this.iconField != null && this.iconField.fields.IconName.value != null"
      >
        <v-icon v-text="this.iconField.fields.IconName.value"></v-icon>
      </v-list-item-icon>
      <v-list-item-title>
        {{ this.linkField.value.text }}
      </v-list-item-title>
    </v-list-item>

    <div class="experience-editor-link" v-else-if="this.isSitecoreExperienceEditorOn">
      <sc-link :field="this.linkField" :editable="this.editable" />
    </div>
  </div>
</template>

<script>
import { Link, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'SitecoreLink',
  data() {
    return {};
  },
  props: {
    iconField: {
      type: Object,
      default: () => ({
        fields: {
          IconName: {
            value: null,
          },
        },
      }),
    },
    linkField: {
      type: Object,
      default: () => ({
        value: {
          linktype: 'internal',
        },
      }),
    },
    editable: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    isInternal() {
      if (
        this.linkField != null &&
        this.linkField.value != null &&
        this.linkField.value.linktype === 'internal'
      ) {
        return true;
      } else {
        return false;
      }
    },
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
  },
  components: {
    ScLink: Link,
  },
};
</script>
<style lang="scss" scoped></style>
